import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./Intro.css";
import emotional from "../../../img/test-images/intro-images/emotional-intro.svg";
import clock from "../../../img/test-images/clock.svg";

function Intro() {
  return (
    <div className="intro-div">
      <Container className="intro-container">
        <Row>
          <Col md={6}>
            <img src={emotional} alt="emotional-intelligence" />
          </Col>
          <Col md={6}>
            <p>
              Emotional Intelligence is the ability to understand or monitor
              your own emotions as well as the emotions of others. It allows us
              to distinguish between and identify different emotions correctly.
            </p>
            <p>
              Emotional Intelligence is what we use when we empathize with our
              co-workers, have deep conversations about our relationships with
              significant others, and attempt to manage an unruly or distraught
              child. It allows us to connect with others, understand ourselves
              better, and live a more authentic, healthy, and happy life.
            </p>
            <div className="test-time">
              <img src={clock} alt="time" />5 - 8 minutes
            </div>
            <Button
              variant="secondary"
              size="lg"
              href="/selfevaluation/emotional-intelligence/quiz"
            >
              Proceed
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Intro;
